import KindType from '../enums/KindType'
export const partMapper = {
  [KindType.facebookPost]: ['text', 'image'],
  [KindType.instagramPost]: ['image', 'text'],
  [KindType.linkedinPost]: ['text', 'image'],
  [KindType.facebookAds]: ['text', 'image'],
  [KindType.newsletter]: ['text', 'image'],
  [KindType.gmbNewsPost]: ['text', 'image'],
  [KindType.gmbProductDescription]: ['text', 'image'],
  [KindType.customerMailing]: ['text'],
  [KindType.blogPost]: ['image', 'text'],
  [KindType.websiteText]: ['image', 'text'],
  [KindType.interview]: ['text'],
  [KindType.whatsappStatus]: ['image', 'text'],
}
